module.exports = __webpack_public_path__ + "img/Image_8.8f9d2b39.png";